import React from 'react'
import styled from 'styled-components'
import TextAreaInput from '@components/Form/TextAreaInput'
import {
    MainButton,
    StyledModal,
    ModalTopPart,
    ModalTitle,
    ModalMainText,
    ModalButtonsContainer,
} from '@appearance/styled'
import i18n from '@localization/i18n'

export default ({
    isOpen,
    onConfirm,
    onCancel,
    title,
    mainText,
    withTextInput,
    textInputValue,
    textInputLabel = '',
    onChangeTextInput,
    textInputRequired = false,
}) => {
    return (
        <StyledModal isOpen={isOpen} onBackgroundClick={onCancel}>
            <ModalTopPart>
                <ModalTitle>{title}</ModalTitle>
                <ModalMainText>{mainText}</ModalMainText>
                {withTextInput && (
                    <StyledTextArea
                        text={textInputValue}
                        label={textInputLabel}
                        onChangeText={(val) => onChangeTextInput(val)}
                        width={'100%'}
                        required={textInputRequired}
                        minHeight={'100px'}
                    />
                )}
            </ModalTopPart>
            <ModalButtonsContainer>
                <MainButton
                    onClick={onConfirm}
                    disabled={
                        withTextInput && textInputRequired && !textInputValue
                    }
                >
                    {i18n.t('modals.confirm')}
                </MainButton>
                <MainButton onClick={onCancel}>ביטול</MainButton>
            </ModalButtonsContainer>
        </StyledModal>
    )
}

const StyledTextArea = styled(TextAreaInput)`
    margin: 20px 0;
`
